import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import AdminContainer from './AdminContainer';
import profileService from '../../services/WebProfileService';

const styles = theme => ({
    root: {
        margin: '1rem'
    },    
    profileItemContainer: {
        marginLeft: "1.2rem",
        marginTop: "1rem",
        display: "flex",
        justifyItems: 'flex-start',
    },
    profileItem: {        
        display: "inlineBlock",        
    },    
    profileItemLabel: {                
        display: "inlineBlock",
        width : '110px'
    },    
    header : {
        marginLeft : '20px',
        fontSize: '18px',
        paddingTop : '20px'
    },
});

class Profile extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            firstName : null,
            email: null,
            admin: false,
            userToRegister: {
                email: null,
                tempPassword: null
            }
        }
    }
    componentDidMount() {
        profileService.getProfile( (results) => {
            this.setState({
                firstName : results.firstName,
                email: results.email,
                admin : results.admin
            })
        });
    }

    profileEntry(id,item, itemName) {
        const { profileItem, profileItemContainer, profileItemLabel } = this.props.classes;
        return (
            <div className={profileItemContainer}>
                <div className={profileItemLabel} >{itemName}:</div>
                <div id={id} className={profileItem}>{item ? item :''}</div>
            </div>
        )
    }

    render() {
        const {classes} = this.props;
        return (<div className={classes.root}>
            <div className={classes.header}>Profile</div>
            {this.profileEntry('first-name',this.state.firstName,"First Name")}
            {this.profileEntry('profile-email',this.state.email,"Email")}            
            {this.state.admin ? <AdminContainer/> : null}
        </div>)
    }
}

export default withStyles(styles)(Profile);